export default __webpack_public_path__ + "static/media/shirt.e68102dd.png";